import React, { memo } from "react";

import { formatCurrency } from "helpers";
import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { getBasePrice, getChannelPrice, getListingTitle, getSelectedChannels } from "../helpers";
import { ListingSceneProps } from "../types";
import ChannelTile from "./ChannelTile";

const CHANNEL_ROW_COUNT = 3;

/** Korak cijene: osnovna cijena i cijena na svakom oglasniku, troškovi uvoza i prilagodba po oglasniku. */
const PriceScene: React.FC<ListingSceneProps> = ({ formValues }) => {
  const channels = getSelectedChannels(formValues).slice(0, CHANNEL_ROW_COUNT);
  const importCost = formValues.marketplaceData.payment.priceIncludesImport;

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Cijena oglasa</div>
          <div className="text-sm font-bold text-slate-800 truncate">{getListingTitle(formValues)}</div>
          <div className="mt-2 text-2xl font-bold text-blue-700">{formatCurrency.format(getBasePrice(formValues))}</div>
          <div className="mt-3 space-y-2">
            {channels.map((channel) => (
              <div key={channel.id} className="flex items-center gap-3 rounded-md bg-slate-50 px-3 py-2 text-[0.7rem]">
                <ChannelTile code={channel.code} name={channel.name} />
                <span className="flex-1 min-w-0 font-medium text-slate-700 truncate">{channel.name}</span>
                <span className="font-semibold text-slate-800">{formatCurrency.format(getChannelPrice(formValues, channel.id))}</span>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Troškovi uvoza</div>
          <div className="mt-2 text-sm font-bold text-slate-800">{importCost === "without" ? "Nisu u cijeni" : "Uključeni u cijenu"}</div>
          <div className="mt-3 inline-flex px-2 py-0.5 rounded-full text-[0.65rem] font-semibold bg-emerald-100 text-emerald-700">
            Kupac zna što plaća
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Cijena po oglasniku"
          subtitle="Svaki oglasnik može imati svoju"
          iconClassName="bg-emerald-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#047857" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M20.6 13.4l-7.2 7.2a2 2 0 01-2.8 0L3 13V3h10l7.6 7.6a2 2 0 010 2.8z" />
              <circle cx="7.5" cy="7.5" r="1.5" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(PriceScene);
